module.exports = __webpack_public_path__ + "img/cuff width.16bacf8f.png";